import {
  getByTagOrgs
} from "@/http/api/organization";
import headerTop from "@/components/HeaderTop";
import {
  validatePhone,
  validateEmail
} from "@/utils/validate";
import {
  getEnumMetaData
} from "@/utils/getEnumMeta";
import {
  addCompanyStore
} from "@/http/api/companyStore";
import {
  getCompanyStoreSettings
} from "@/http/api/system";
import {
  getCompaniesSearch
} from "@/http/api/company";
import {
  getUsersSearch
} from "@/http/api/employe";
export default {
  components: {
    headerTop,
  },
  data() {
    var validateNumber = (rule, value, callback) => {
      if (value === "" || value == null) {
        callback(new Error('尚未输入'));
      }
      if (isNaN(value)) {
        //对于空数组和只有一个数值成员的数组或全是数字组成的字符串，isNaN返回false，例如：'123'、[]、[2]、['123'],isNaN返回false,
        //所以如果不需要val包含这些特殊情况，则这个判断改写为if(!isNaN(val) && typeof val === 'number' )
        
        callback(new Error('请输入数字'));
      }
      else {
        callback();
      }
    };
    var validateFormPhone = (rule, value, callback) => {
      if (value === '') {
        callback();
      } else if (!validatePhone(value)) {
        callback(new Error('手机号格式不正确'));
      } else {
        callback();
      }
    };
    var validateFormEmail = (rule, value, callback) => {
      if (value === '') {
        callback();
      } else if (!validateEmail(value)) {
        callback(new Error('邮箱格式不正确'));
      } else {
        callback();
      }
    };
    return {
      headerText: '添加分销商门店',
      submitLoading: false,

      //远程搜索下拉框
      orgList: [],
      getOrgLoading: false,
      companyList: [],
      getCompanyLoading: false,
      userList: [],
      getUserLoading: false,

      //提交参数
      photoUrl: '',
      photoFile: {}, //文件
      companyStore: {
        organizationId: '',
        companyId: '',
        userId: '',
        name: '', //名称
        email: '', //邮箱
        phoneNumber: '', //手机号
        registerAddress: '', //工商注册地址
        currentAddress: '', //实际经营地址
        isMaster: false, //是否是主店
        businessName: '', //营业执照名称
        businessLicense: '', //营业执照号码
        longitude: '',
        latitude: '',
        lastAllowWorkTime: '', //最晚开业核准日期
        actualAllowWorkTime: '', //实际开业核准日期
        contractNumber: '', //加盟合同编号
        contractStartTime: '', //加盟合同生效时间
        contractEndTime: '', //加盟合同结束时间
        paymentStartTime: '', //特费缴费开始时间
        paymentEndTime: '', //特费缴费结束时间
        closeStartTime: '', //歇业开始时间
        closeEndTime: '', //歇业结束时间
        rent: '', //分销商门店租金
        area: '', //分销商门店面积
        dropWay: '', //分销商门店退出方式
        dropTime: '', //分销商门店退出时间
        type: 'Direct', //分销商门店类型
        status: "Waiting", //分销商门店状态
        deposit: 0, //保证金
        joinFee: 0, //加盟费
        paymentType: 'FixedMoney', //支付类型
        paymentMoney: 0, //收费金额
        paymentRate: 0, //收费比例
        leastPaymentMoney: 0, //收费保底费用
        paymentDescription: 0, //收费政策描述
        more: '', //备注
        tags: [], //标签
      },
      companyStoreRules: {
        // paymentDescription: [{
        //   required: true,
        //   message: '请输入收费政策描述',
        //   trigger: 'blur'
        // }],
        // leastPaymentMoney: [{
        //   required: true,
        //   message: '请输入收费保底费用',
        //   trigger: 'blur'
        // }, {
        //   validator: validateNumber,
        //   trigger: 'blur'
        // }],
        // paymentRate: [{
        //   required: true,
        //   message: '请输入收费比例',
        //   trigger: 'blur'
        // }, {
        //   validator: validateNumber,
        //   trigger: 'blur'
        // }],
        // paymentMoney: [{
        //   required: true,
        //   message: '请输入收费金额',
        //   trigger: 'blur'
        // }, {
        //   validator: validateNumber,
        //   trigger: 'blur'
        // }],
        // paymentType: [{
        //   required: true,
        //   message: '请选择支付类型',
        //   trigger: 'change'
        // }],
        // joinFee: [{
        //   required: true,
        //   message: '请输入加盟费',
        //   trigger: 'blur'
        // }, {
        //   validator: validateNumber,
        //   trigger: 'blur'
        // }],
        // deposit: [{
        //   required: true,
        //   message: '请输入保证金',
        //   trigger: 'blur'
        // }, {
        //   validator: validateNumber,
        //   trigger: 'blur'
        // }],
        // type: [{
        //   required: true,
        //   message: '请选择分销商门店类型',
        //   trigger: 'change'
        // }],
        // status: [{
        //   required: true,
        //   message: '请选择分销商门店状态',
        //   trigger: 'change'
        // }],
        organizationId: [{
          required: true,
          message: '请选择组织',
          trigger: 'change'
        }],
        companyId: [{
          required: true,
          message: '请选择分销商',
          trigger: 'change'
        }],
        // userId: [{
        //   required: true,
        //   message: '请选择分销商负责人',
        //   trigger: 'change'
        // }],
        name: [{
          required: true,
          message: '请输入分销商门店名称',
          trigger: 'blur'
        }],
        email: [{
          required: false,
          message: '请输入电子邮箱',
          trigger: 'blur'
        }, {
          validator: validateFormEmail,
          trigger: 'blur'
        }],
        phoneNumber: [{
          required: false,
          message: '请输入联系电话',
          trigger: 'blur'
        }, {
          validator: validateFormPhone,
          trigger: 'blur'
        }],
        // isMaster: [{
        //   required: true,
        //   message: '请选择是否是主店',
        //   trigger: 'change'
        // }],
        // businessName: [{
        //   required: true,
        //   message: '请输入营业执照名称',
        //   trigger: 'blur'
        // }],
        // businessLicense: [{
        //   required: true,
        //   message: '请输入营业执照号码',
        //   trigger: 'blur'
        // }],
      },
      companyPayMentOptions: [], //分销商门店支付方式
      companyTypeOptions: [], //分销商门店类型
      companyStatusOptions: [], //分销商门店状态
      companyDropWayOptions: [], //分销商门店退出方式
      // 证件类型
      ownerCardTypeOptions: [{
        option: '大陆身份证',
      }, {
        option: '军官证',
      }, {
        option: '港台身份证',
      }, {
        option: '护照',
      }, {
        option: '驾驶证',
      }, {
        option: '其他',
      }],
    }
  },
  mounted() {
    this.getCompanyStoreSettings();
    this.getOrganization()
    //分销商门店类型
    this.companyTypeOptions = getEnumMetaData(this.$store.getters.enumMetadata, 'CompanyStoreType');
    //分销商门店状态
    this.companyStatusOptions = getEnumMetaData(this.$store.getters.enumMetadata, 'CompanyStoreStatus');
    //分销商门店支付类型
    this.companyPayMentOptions = getEnumMetaData(this.$store.getters.enumMetadata, 'CompanyStorePaymentType');
  },
  methods: {
    // 获取组织机构
    getOrganization(e) {
      this.getOrgLoading = true;
      let query={
        tag: '店',
        Filter: e,
        maxResultCount: 1000,
        PermissionFilter : true
      }
      getByTagOrgs(query).then((res) => {
        this.getOrgLoading = false;
        this.orgList = res.result.items;
      }).catch(err=>{
        this.getOrgLoading = false
      });
    },
    // 获取公司
    getCompany(e) {
      this.getCompanyLoading = true;
      var params = {
        filter: e,
        condition: "Name",
        timeCondition: "",
        startTime: "",
        endTime: "",
        status: "",
        type: "",
        sorting: "",
        skipCount: 0,
        maxResultCount: 999,
      };
      getCompaniesSearch(params).then(res => {
        this.getCompanyLoading = false;
        this.companyList = res.result.items;
      })
    },
    // 获取负责人
    getUser(e) {
      this.getUserLoading = true;
      var params = {
        changeType: "",
        changeReviewStatus: "",
        isWorkingUser: null,
        filter: e,
        timeCondition: "",
        startTime: "",
        endTime: "",
        status: "",
        type: "",
        sorting: "",
        skipCount: 0,
        maxResultCount: 999,
      };
      let query = "";
      for (var key in params) {
        if (params[key] !== null && params[key] !== "") {
            query = `${key}=${params[key]}&${query}`;
        }
      }
      getUsersSearch(query).then(res => {
        this.getUserLoading = false;
        this.userList = res.result.items;
      })
    },
    // 获取分销商门店基础字段
    getCompanyStoreSettings() {
      getCompanyStoreSettings().then(res => {
        res.result.forEach(item => {
          switch (item.name) {
            case 'Deer.Company.Nature':
              break;
            case 'Deer.Company.RecruitWay':
              break;
            case 'Deer.Company.Collection.MaterialType': //资料附件类型
              break;
            case 'Deer.Company.EventType': //大事记类型
              break;
            case 'Deer.CompanyStore.Collection.DropWay': //分销商门店退出方式
              this.companyDropWayOptions = item.value;
              break;
            case 'Deer.Company.Collection.MaterialType': //分销商门店资料附件类型
              break;
            case 'Deer.Company.Collection.EventType': //分销商门店大事记类型
              break;
          }
        });
      });
    },
    //添加分销商门店
    addCompanyStore() {
      var formData = new FormData();
      formData.append("CompanyStore", JSON.stringify(this.companyStore));
      if (JSON.stringify(this.photoFile) != "{}") {
        formData.append("PhotoFile", this.photoFile);
      }
      addCompanyStore(formData).then(res => {
        if(res.code==10200){
        this.$message({
          showClose: true,
          message: '分销商门店信息添加成功',
          type: 'success'
        });
        this.$router.go(-1);
      }
      }).catch(err=>{
        this.$message({
          showClose: true,
          message: err.error.message,
        });
      });
    },
    createCompany(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 加盟合同生效时间不得大于结束时间
          if (this.companyStore.contractStartTime && this.companyStore.contractEndTime && this.companyStore.contractStartTime > this.companyStore.contractEndTime) {
            this.$message.success({
              message: "加盟合同生效时间不得大于结束时间",
              showClose: true
            });
            return;
          }
          // 特费缴费开始结束时间
          if (this.companyStore.paymentStartTime && this.companyStore.paymentEndTime && this.companyStore.paymentStartTime > this.companyStore.paymentEndTime) {
            this.$message.success({
              message: "特费缴费开始时间不得大于结束时间",
              showClose: true
            });
            return;
          }
          this.addCompanyStore();
        } else {
          
          return false;
        }
      });
    },
    // 上传头像回调
    uploadChange(file) {
      this.photoUrl = file.url;
    },
    //图片大小
    beforeAvatarUpload(file) {
      const isPIC = file.type.indexOf("image") != -1;
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isPIC) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isPIC && isLt5M;
    },
    //上传图片
    getFile(item) {
      this.photoFile = item.file;
    },
  }
};